import './index.scss'
import { observer } from 'mobx-react-lite'
import DoubleTick from '@assets/svg/header/notifications/double-tick.svg';
import NotificationUserOne from '@assets/img/header/notifications/userAvatarOne.png';
import NotificationUserTwo from '@assets/img/header/notifications/userAvatarTwo.png';
import NotificationUserThree from '@assets/img/header/notifications/userAvatarThree.png';

const exampleNotification = [
    {
        id: 1,
        time: '23:15',
        img: NotificationUserOne,
        name: 'Aleksandra Petrova',
        text: 'sifarişinizə müraciət etdi'
    },
    {
        id: 2,
        time: '23:15',
        img: NotificationUserTwo,
        name: 'Andrey Sinyavin',
        text: 'sizə şəxsi mesaj yazdı'
    },
    {
        id: 3,
        time: '23:15',
        img: NotificationUserThree,
        name: 'Sergey Vorobyov',
        text: 'sifarişinizə müraciət etdi'
    },
];

const NotificationPage = observer(() => {
    return (
        <div className="notification-page">
            <div className="title">
                Bildirişlər
            </div>
            <div className="read-all-block">
                <div className="read-all">
                    <img src={DoubleTick} /><span>Hamısını oxu</span>
                </div>
            </div>
            <div className="day">
                <div className="day-title">Cümə axşamı, 11 avqust, 2022</div>
                <div className="notifications">
                    {exampleNotification && exampleNotification.map((notification, index) =>
                        <div key={`notification_${index}`} className="notification">
                            <div className="time">{notification.time}</div>
                            <div className="user-image">
                                <img src={notification.img} />
                            </div>
                            <div className="message">
                                <span className="name">{notification.name}</span>{' '}
                                <span>{notification.text}</span>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <div className="day">
                <div className="day-title">Çərşənbə, 10 avqust, 2022</div>
                <div className="notifications">
                    {exampleNotification && exampleNotification.map((notification, index) =>
                        <div key={`notification_${index}`} className="notification">
                            <div className="time">{notification.time}</div>
                            <div className="user-image">
                                <img src={notification.img} />
                            </div>
                            <div className="message">
                                <span className="name">{notification.name}</span>{' '}
                                <span>{notification.text}</span>
                            </div>
                        </div>
                    )}
                </div>
            </div>

        </div>
    )
})

export {NotificationPage}